var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 12.2C16.2863 12.2 13.6 14.8863 13.6 18.2V24.4485L11.2 26.8485V27.2H28V26.8485L25.6 24.4485V18.2C25.6 14.8863 22.9137 12.2 19.6 12.2ZM12.4 18.2C12.4 14.2235 15.6235 11 19.6 11C23.5764 11 26.8 14.2235 26.8 18.2V23.9515L29.2 26.3515V28.4H10V26.3515L12.4 23.9515V18.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4057 10.4C17.4057 9.07452 18.4802 8 19.8057 8C21.1312 8 22.2057 9.07452 22.2057 10.4V11.6H17.4057V10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2057 29.6C22.2057 29.9152 22.1436 30.2273 22.023 30.5184C21.9024 30.8096 21.7256 31.0742 21.5028 31.2971C21.2799 31.5199 21.0153 31.6967 20.7242 31.8173C20.433 31.9379 20.1209 32 19.8057 32C19.4905 32 19.1785 31.9379 18.8873 31.8173C18.5961 31.6967 18.3315 31.5199 18.1087 31.2971C17.8858 31.0742 17.709 30.8096 17.5884 30.5184C17.4678 30.2273 17.4057 29.9152 17.4057 29.6H22.2057Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/Bell-Icon.bca2f03091836e189404b17df76167b0.svg";
export { ForwardRef as ReactComponent };